import { ModuleFE_OrganizationPermission } from './ModuleFE_OrganizationPermission.js';
export const ModulePackFE_OrganizationPermissionModule = [ModuleFE_OrganizationPermission];
//# sourceMappingURL=module-pack.js.map